/* eslint_disable global_require */
import zhCN from "antd/es/locale/zh_CN";
import enUS from "antd/es/locale/en_US";
import mnMN from "antd/es/locale/mn_MN"; // 马来语

const zh = require("../locales/zh_CN.json");
const en = require("../locales/en_US.json");

export const appLocales = {
  zh_CN: zh,
  en_US: en,
};

export const antdLocales = {
  zh_CN: zhCN,
  en_US: enUS,
};

export const languages = {
  zh_CN: "中文",
  en_US: "English",
};

export const languagesList = [
  {
    title: "简体中文",
    value: "zh_CN",
  },
  {
    title: "English",
    value: "en_US",
  },
  // {
  //   title: "Bahasa Melayu",
  //   value: "mn_MN",
  // },
];
